import { legalMoves } from './game';
import { requestMove } from './api';

export const HUMAN = 'human';

export const llm = async (game, { hintLegalMoves, ...settings }) => {
    const openCells = legalMoves(game);

    const answer = await requestMove({
        board: game.board,
        turn: game.turn,
        ...(hintLegalMoves && { legalMoves: openCells }),
        ...settings,
    });

    return { ...answer, hintLegalMoves, illegal: !openCells.includes(answer.cell) };
};

export const TWO_PLAYERS = { X: HUMAN, O: HUMAN };
export const VS_AI = { X: HUMAN, O: llm };
